import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.EditReviewersPopup', {
    changeReviewers: 'Change Reviewers',
    addReviewer: 'Add Reviewer',
    done: 'Done',
    description:
        'Add or remove Reviewers in the step Review step.{br}Please provide a comment to let {authorName} as well as the Reviewers know why you decided to do this.',
});
